import "./reviews.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { Stars } from "../../../../components/landing/ui/Stars/Stars";
import { SectionTitle } from "../../../../components/landing/ui/SectionTitle/SectionTitle";
import { Slider } from "../../../../components/landing/ui/Slider/Slider";
import { useEffect, useState } from "react";

const MOBILE_MAX = 768;

function useIsMobile(maxWidth = MOBILE_MAX) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const calc = () => setIsMobile(window.innerWidth <= maxWidth);
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, [maxWidth]);

  return isMobile;
}

type ReviewItem = {
  rating: number;
  text: string;
  name: string;
  position: string;
};

export const Reviews = () => {
  const data = useHomeContent();
  const isMobile = useIsMobile();
  const sliderAria = data?.common?.sliderAria;

  const reviewsBlock = data?.reviews;
  const reviews: ReviewItem[] = Array.isArray(reviewsBlock)
    ? reviewsBlock
    : reviewsBlock?.items ?? [];
  const title =
    (!Array.isArray(reviewsBlock) && reviewsBlock?.title) ??
    data?.reviewsTitle ??
    "";

  if (!reviews.length) return null;

  return (
    <section className="oc-reviews oc-section">
      <div className="oc-container">
        <SectionTitle title={title} />

        <div className="oc-reviews__shell">
          <Slider
            items={reviews}
            className="oc-reviews__slider"
            renderItem={(r: ReviewItem) => <ReviewCard r={r} />}
            breakpoint={{
              mobileMaxWidth: 768,
              slidesToShowMobile: 1,
              slidesToShowDesktop: 3,
            }}
            gap={20}
            showDots={true}
            showArrows={!isMobile}
            swipe={true}
            loop={true}
            autoPlay={true}
            autoPlayIntervalMs={9000}
            arrowIconUrl={"/assets/icons/arrow.svg"}
            arrowDirection="left"
            ariaLabels={sliderAria}
          />
        </div>
      </div>
    </section>
  );
};

const ReviewCard = ({ r }: { r: ReviewItem }) => {
  return (
    <div className="oc-reviews__card">
      <div className="oc-reviews__stars">
        <Stars value={r.rating} />
      </div>

      <div className="oc-reviews__text">{r.text}</div>

      <div className="oc-reviews__divider" />

      <div className="oc-reviews__footer">
        <div className="oc-reviews__name">{r.name}</div>
        <div className="oc-reviews__pos">{r.position}</div>
      </div>
    </div>
  );
};
